import './NotFound.css'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className='notFound-container'>
      <h1>Page Not Found</h1>
      <Link to="/" className='btn'>Go Back Home</Link>
    </div>
  )
}

export default NotFound